<template>
<div>

<!--メインコンテンツ-->
<div class="bbrCom_setStdCnt bbrCom_setColFill">
  
  <!--チームを選ぶ-->
  <div class="bbrCom_selectMenu bbrTem_selectTeam">
  <label>
  <select id="bbrTem_selectTeamId" onchange="location.href = this.options[selectedIndex].value">
    <option>チームを選ぶ</option>
    <template v-for="(team) in json.teamList">
      <option v-bind:value="$config.baseUrl + '?kd_page=team_record&team_id=' + team.globalId + '&vsteam_id=' + getVsTeamId(team.globalId)" :key="team.id">{{ team.nickname }}</option>
    </template>
  </select>
  </label>
  </div>
  <!--/チームを選ぶ-->
  <!--<div class="bbrCom_attHyoki"><a href="#" class="bbrCom_linkHyoki"><span>各表記について</span></a></div>-->
  
  <h2 class="bbrCom_ttl"><span v-bind:class="'bbrCom_blTeam' + json.team.id">{{ json.team.name }}</span></h2>
  
  <!--チーム情報ページ_メインメニュー-->
  <ul id="bbrTem_mainMenu" class="bbrCom_tabMenu02">
    <li><a v-bind:href="$config.baseUrl + '?kd_page=team&team_id=' + json.team.globalId">チームトップ</a></li>
    <li><a v-bind:href="$config.baseUrl + '?kd_page=team_member&team_id=' + json.team.globalId">所属選手</a></li>
    <li>
      <a v-if="gameJson != null" v-bind:href="$config.baseUrl + '?kd_page=team_result&team_id=' + json.team.globalId + '&month=' + getMonth(json.gameDate)">日程・結果</a>
      <a v-else href="">日程・結果</a>
    </li>
    <li><a v-bind:href="$config.baseUrl + '?kd_page=team_record&team_id=' + json.team.globalId + '&vsteam_id=' + getVsTeamId(json.team.globalId )" class="bbrCom_current">対戦・成績</a></li>
  </ul>
  <!--/チーム情報ページ_メインメニュー-->
  
  <!--リーグリスト-->
  <div class="bbrTem_leagueList bbrCom_cf">
    <span>ア・リーグ</span>
    <ul class="bbrCom_tabMenu01">
      <template v-for="(team) in json.cTeamList">
      <li v-if="json.team.globalId != team.globalId" :key="team.id">
        <a v-bind:href="$config.baseUrl + '?kd_page=team_record&team_id=' + json.team.globalId + '&vsteam_id=' + team.globalId">{{ team.nickname }}</a>
      </li>
      </template>
    </ul>
  </div>
  <div class="bbrTem_leagueList bbrCom_mb50 bbrCom_cf">
    <span>ナ・リーグ</span>
    <ul class="bbrCom_tabMenu01">
      <template v-for="(team) in json.pTeamList">
      <li v-if="json.team.globalId != team.globalId" :key="team.id">
        <a v-bind:href="$config.baseUrl + '?kd_page=team_record&team_id=' + json.team.globalId + '&vsteam_id=' + team.globalId">{{ team.nickname }}</a>
      </li>
      </template>
    </ul>
  </div>
  <!--/リーグリスト-->
  

  
  <h3 class="bbrCom_ttlSc">VS {{ json.vsTeam.nickname }}対戦日程
    <span v-if="json.gameType == 0">（オープン戦）</span>
    <span v-if="json.gameType == 1">（公式戦）</span>
  </h3>
  
  <!--2017年4月-->
  <template v-if='json.schedule == null'>
    <div class="bbrCom_mb50">日程データがありません</div>
  </template>
  <template v-for='(gameList, month) in getGameScheduleList()'>
    <h3 class="bbrCom_ttlSc-s" :key="'M' + month">-{{ month }}</h3>
    <table class="bbrCom_tbl bbrCom_tblResult bbrCom_tbl-nonth bbrCom_mb30" :key="month">
      <tbody>
        <tr v-for='(game) in gameList' v-bind:key="game.gameGlobalId">
          <td>{{ getFormattedDay(game.gameDate) }}<br>{{ getFormattedStartTime(game.startTime) }}</td>
          <td>
            <span class="bbrCom_ndS">{{ game.venueNickName }}</span>
          </td>
          <td>
          <template v-if="game.gameStatusName == '試合前' || game.gameStatusName == '中止'">
            <ul>
              <li>
                <span class="bbrCom_ndS">{{ game.visitor.nickname }}</span>
                <span class="bbrCom_ndP">{{ game.visitor.nickname }}</span>
              </li>
              <li>
                <p>{{ game.gameStatusName }}</p>
              </li>
              <li>
                <span class="bbrCom_ndS">{{ game.home.nickname }}</span>
                <span class="bbrCom_ndP">{{ game.home.nickname }}</span>
              </li>
            </ul>
          </template>
          <template v-else-if="game.gameStatusName == 'ノーゲーム' || game.gameStatusName == 'サスペンデッド'">
            <a v-bind:href="getGameLink($config.baseUrl, game)">
              <ul>
              <li>
                <span class="bbrCom_ndS">{{ game.visitor.nickname }}</span>
                <span class="bbrCom_ndP">{{ game.visitor.nickname }}</span>
              </li>
              <li>
                <p>{{ game.gameStatusName }}</p>
              </li>
              <li>
                <span class="bbrCom_ndS">{{ game.home.nickname }}</span>
                <span class="bbrCom_ndP">{{ game.home.nickname }}</span>
              </li>
            </ul>
            </a>
          </template>
          <template v-else>
            <a v-bind:href="getGameLink($config.baseUrl, game)">
              <ul>
              <li>
                <span class="bbrCom_ndS">{{ game.visitor.nickname }}</span>
                <span class="bbrCom_ndP">{{ game.visitor.nickname }}</span>
              </li>
              <li>
                <span>{{ game.visitor.score }}</span>
                <span>-</span>
                <span>{{ game.home.score }}</span>
              </li>
              <li>
                <span class="bbrCom_ndS">{{ game.home.nickname }}</span>
                <span class="bbrCom_ndP">{{ game.home.nickname }}</span>
              </li>
            </ul>
            </a>
          </template>
          </td>
          <td>
            <dl>
              <template v-if="game.gameStatusName == '試合終了'">
                 <template v-if="game.home.winLose == 'Win' || game.home.winLose == 'true' || game.visitor.winLose == 'Win' || game.visitor.winLose == 'true'">
                  <dt>勝</dt>
                  <template v-if="(game.home.winLose == 'Win' || game.home.winLose == 'true') && game.home.pitcher != null">
                    <dd>{{ game.home.pitcher }}</dd>
                  </template>
                  <template v-else-if="(game.visitor.winLose == 'Win' || game.visitor.winLose == 'true') && game.visitor.pitcher != null">
                    <dd>{{ game.visitor.pitcher }}</dd>
                  </template>
                  <template v-else>
                    <dd>&nbsp;</dd>
                  </template>
                  <template v-if="game.savePitcher != null">
                    <dt>S</dt>
                    <dd>{{ game.savePitcher }}</dd>
                  </template>
                </template>
                <template v-else>
                <dd>&nbsp;</dd>
                </template>
              </template>
              <template v-else-if="game.gameStatusName == '試合前'">
                <template v-if="game.visitor.startingPitcher == null">
                <dt>&nbsp;</dt>
                </template>
                <template v-else>
                <dt>予</dt>
                </template>
                <dd v-if="game.visitor.startingPitcher == null">&nbsp;</dd>
                <dd v-else>{{ game.visitor.startingPitcher }}</dd>
              </template>
              <template v-else-if="game.gameStatusName == '試合中'">
                <dt>&nbsp;</dt>
                <dd v-if="game.visitor.pitcher == null">&nbsp;</dd>
                <dd v-else>{{ game.visitor.pitcher }}</dd>
              </template>
              <template v-else>
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
              </template>

              <template v-if="game.gameStatusName == '試合終了'">
                <template v-if="game.home.winLose == 'Loss' || game.home.winLose == 'false' || game.visitor.winLose == 'Loss' || game.visitor.winLose == 'false'">
                  <dt>負</dt>
                  <template v-if="(game.home.winLose == 'Loss' || game.home.winLose == 'false') && game.home.pitcher != null">
                    <dd>{{ game.home.pitcher }}</dd>
                  </template>
                  <template v-else-if="(game.visitor.winLose == 'Loss' || game.visitor.winLose == 'false') && game.visitor.pitcher != null">
                    <dd>{{ game.visitor.pitcher }}</dd>
                  </template>
                  <template v-else>
                    <dd>&nbsp;</dd>
                  </template>
                </template>
                <template v-else>
                <dd>&nbsp;</dd>
                </template>
              </template>
              <template v-else-if="game.gameStatusName == '試合前'">
                <template v-if="game.home.startingPitcher == null">
                <dt>&nbsp;</dt>
                </template>
                <template v-else>
                <dt>予</dt>
                </template>
                <dd v-if="game.home.startingPitcher == null">&nbsp;</dd>
                <dd v-else>{{ game.home.startingPitcher }}</dd>
              </template>
              <template v-else-if="game.gameStatusName == '試合中'">
                <dt>&nbsp;</dt>
                <dd v-if="game.home.pitcher == null">&nbsp;</dd>
                <dd v-else>{{ game.home.pitcher }}</dd>
              </template>
              <template v-else>
                <dt>&nbsp;</dt>
                <dd>&nbsp;</dd>
              </template>
            </dl>
          </td>
        </tr>
      </tbody>
    </table>
  </template>
  
 </div>
<!--/メインコンテンツ-->


<!--他球団の試合-->
<div id="bbrCom_gameResult"></div>
<!--他球団の試合-->
<Copyright></Copyright>
</div>
</template>

<script>
import utilsMixin from '../utils';
import Copyright from './Copyright.vue';

export default {
  mixins: [utilsMixin],
  components: {
    Copyright
  },
  data: function () {
    return {
      json: null,
      gameJson: null,
    }
  },
  mounted: async function() {
    this.gameJson = await this.loadLatestGame();
    this.$config.callback();
  },
  methods: {
    getWinRate: function (type) {
      let homeWin = this.json.teamStandingsSplits.win;
      let visitorWin = this.json.teamStandingsSplits.lose;
      let total = parseInt(homeWin) + parseInt(visitorWin);
      if (type == 'home') {
        let result = String((Math.round(homeWin / total * 1000) / 1000).toFixed(3));
        if (isNaN(result)) {
          return '.000';
        }
        return result.replace('0.', '.');
      } else {
        let result = String((Math.round(visitorWin / total * 1000) / 1000).toFixed(3));
        if (isNaN(result)) {
          return '.000';
        }
        return result.replace('0.', '.');
      }
    },
    getTeamStandingsSplitsWidth: function (type) {
      let homeWin = this.json.teamStandingsSplits.win;
      let visitorWin = this.json.teamStandingsSplits.lose;
      let total = parseInt(homeWin) + parseInt(visitorWin) + parseInt(this.json.teamStandingsSplits.tie);
      if (type == 'home') {
        return `1% * (${homeWin} / ${total}) * 100`;
      } else {
        return `1% * (${visitorWin} / ${total}) * 100`;
      }
    },
    getTeamStatsWidth: function (baseValue, value) {
      if (baseValue >= value) {
        return `1% * 100 * 0.8`;
      } else {
        return `1% * (${baseValue} / ${value}) * 100 * 0.8`;
      }
    },
    getDescTeamStatsWidth: function (baseValue, value) {
      baseValue = parseFloat(baseValue);
      value = parseFloat(value);
      if (baseValue >= value) {
        return `1% * 100 * 0.8`;
      } else {
        return `1% * (${baseValue} / ${value}) * 100 * 0.8`;
      }
    },
    getAscTeamStatsWidth: function (baseValue, value) {
      baseValue = parseFloat(baseValue);
      value = parseFloat(value);
      if (baseValue <= value) {
        return `1% * 100 * 0.8`;
      } else {
        return `1% * (${value} / ${baseValue}) * 100 * 0.8`;
      }
    },
    getGameScheduleList: function () {
      let gameScheduleList = {};
      let schedule = this.json.schedule;
      if (schedule) {
        const gameJson = this.gameJson;
        Object.keys(schedule).forEach(function (month) {
          gameScheduleList[month] = [];
          schedule[month].forEach((game) => {
            gameScheduleList[month].push(game);
          });

          gameScheduleList[month].forEach(function(game, index){
            if (gameJson) {
              gameJson.gameList.forEach(function(todayGame){
                // 当日の試合情報で、試合開始時間と会場以外を上書き
                if (game.gameGlobalId == todayGame.gameGlobalId) {
                  const copy = Object.assign({}, todayGame);
                  copy.gameDate = game.gameDate;
                  copy.startTime = game.startTime;
                  copy.venueName = game.venueName;
                  copy.venueNickName = game.venueNickName;
                  gameScheduleList[month][index] = copy;
                }
              });
            }
          });
        });
      }
      return gameScheduleList;
    },
  }
}
</script>